<template>
    <div class="container">

        <div v-if="isPay" style="margin-top: 20%;text-align: center;">
            <img src="@/assets/pay_order.png" style="width: 50%;" />

            <div style="padding: 20px 0px;font-size: 20px;">为你保护安全支付</div>
        </div>

        <!-- 未支付展现的页面 -->
        <div v-else>
            <div class="header">
                <div class="residue">剩余支付时间</div>

                <div class="paytime">
                    <span class="time">{{ minutes }}</span>
                    <span class="delimiter">:</span>
                    <span class="time">{{ seconds }}</span>
                    <span class="delimiter">:</span>
                    <span class="time">{{ millisecond }}</span>
                </div>
                <div class="pay-btn" @click="createPay()">继续支付</div>
                <div class="overdue">逾时将不再享红包特惠</div>
            </div>

            <div class="content2">
                <div class="record-bg">
                    <img :src="recordBg" style="width: 100%;display: block;" />
                    <div class="record-bg-txt">学员笔记</div>
                </div>
                <div class="content_list">
                    <div class="content_list-for" v-for="i in 100" v-if="listUser.length > 0">
                        <div class="item" v-for="item in listUser">
                            <img :src="item.img" />
                            <div class="right">
                                <div class="name">{{ item.name }}</div>
                                <div class="desc">{{ item.detail }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer-fit" style="position: fixed;left: 0;right: 0;bottom: 0;">
                <div class="p-left">
                    <div style="font-size: 15px;opacity: 0.8;">限时前200名</div>
                    <div style="font-size: 18px;font-weight: bold;">仅需:￥{{ detail.price }}元</div>
                </div>
                <div class="p-right" @click="createPay()">继续支付</div>
            </div>
        </div>

        <!-- 弹幕 -->
        <!-- <div class="danmu" :class="isDanmu ? 'fade-out' : 'fade-in'" v-if="!isPay">
            <img :src="danmus.img" style="width: 20px;height: 20px;border-radius: 50px;" />
            <div style="padding: 0 10px;">{{ danmus.name }}</div>
            <div>{{ danmus.time }}</div>
            <div>报名了课程</div>
        </div> -->

        <DanmuView v-if="!isPay" wenAn="报名了课程"></DanmuView>

    </div>
</template>

<script>
var that;
import { Toast } from 'vant';
import wx from 'weixin-js-sdk'
import DanmuView from '@/components/danmuView/danmuView.vue';

export default {
    name: 'LoginIndex',
    components: {
        DanmuView
    },
    props: {},
    data() {
        return {
            recordBg: require('@/assets/record_bg.png'),
            minutes: '00',
            seconds: '00',
            millisecond: '00',
            intervalId: null,
            interval_miao: null,
            listUsers: [{
                name: '陈静',
                img: require('@/assets/avatar1.jpg'),
                detail: '以前孩子写字真的很马虎，字迹潦草，每次家长会都被班主任点名批评。抱着试一试的态度加入了学小成写字训练营，不出5天孩子的字迹有了明显的提升，真的让人很惊讶'
            }, {
                name: '熊琪琪',
                img: require('@/assets/avatar2.jpg'),
                detail: '孩子现在写字越来越好看了，专注力也跟着提高了，学习状态比以前要好，在这里谢谢老师'
            }, {
                name: '肖倩',
                img: require('@/assets/avatar3.jpg'),
                detail: '抱着试一试的态度加入了学小成写字训练营，不出5天孩子的字迹有了明显的提升，真的让人很惊讶，孩子现在写字越来越好看了，专注力也跟着提高了，学习状态比以前要好，在这里谢谢老师'
            }],
            listUser: [],
            danmus: {
                img: require('@/assets/avatar2.jpg'),
                name: '陈*',
                time: '5秒前'
            },
            id: "",
            orderId: "",
            pagesType: "",
            token: "",

            zfbHbType: 3,
            payShow: false,
            checkedPay: 'wx',
            orderPrice: 0,
            zfbHbList: [],
            danmuTimer: null,
            isDanmu: false,
            isPay: false,
            detail: {}
        }
    },
    computed: {},
    watch: {},
    created() {
        that = this
        that.id = this.$route.query.id;
        that.orderId = this.$route.query.orderId || '';
        that.pagesType = this.$route.query.pagesType || '';
        that.token = localStorage.getItem('token') || '';
        console.log(!that.orderId)
        if (that.orderId) {
            this.createPay()
        }
        that.getChannelsInfo();
        that.getOrderDetail();
        setTimeout(() => {
            that.listUser = that.listUsers;
        }, 500);
        // setInterval(() => {
        //     that.getPhone()
        // }, 5000);
    },
    destroyed() {
        this.clearTask()
    },
    watch: {
        'isPay'(x, j) {
            if (x) {
                document.title = '安全支付中';

            } else {
                document.title = '订单支付';
            }
        }
    },
    methods: {
        getOrderDetail() {
            this.$http.get('/app/channels/getOrder', {
                id: this.id
            }).then(res => {
                if (res.code == 401) {
                    localStorage.removeItem('token');
                    this.token = '';
                    this.$toast('登录已失效，请重新登录')
                    return
                }
                if (!res.data) {
                    that.$toast('订单已关闭')
                    return
                }
                this.orderId = res.data.id;

                // 设置倒计时间隔和初始更新
                if (res.data.status == 0) {
                    that.clearTimer()
                    that.countdownTime = new Date(res.data.createdTime).getTime() + 15 * 60 * 1000 // 15分钟
                    console.log(that.countdownTime)
                    that.intervalId = setInterval(() => {
                        that.updateCountdown(that.countdownTime)
                    }, 200)
                    that.millisecond = 99
                    that.interval_miao = setInterval(() => {
                        that.millisecond--
                        if (that.millisecond < 10) {
                            that.millisecond = '0' + that.millisecond
                        }
                        if (that.millisecond <= 0) {
                            that.millisecond = 99
                        }
                    }, 10)
                }
            })
        },

        //去支付的时候变成true，手动点去支付重新变成false
        createPay() {
            var that = this;
            this.isPay = true;
            that.$http.post('/app/orders/createPay', {
                id: that.orderId,
                payType: 3
            }).then(res => {
                if (res.data) {
                    const result = res.data
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: result.appId, // 必填，公众号的唯一标识
                        timestamp: result.timeStamp, // 必填，生成签名的时间戳
                        nonceStr: result.nonceStr, // 必填，生成签名的随机串
                        signature: result.paySign, // 必填，签名
                        jsApiList: ['chooseWXPay']
                    })
                    wx.ready(function () {
                        wx.checkJsApi({
                            jsApiList: ['chooseWXPay'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                            success: function () { }
                        })
                    })
                    wx.chooseWXPay({
                        timestamp: result.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: result.nonceStr, // 支付签名随机串，不长于 32 位
                        package: result.packageVal, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: result.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: result.paySign, // 支付签名
                        success(res) {
                            console.log('支付成功', res)
                            that.clearTask()
                            that.$toast('支付成功')
                            setTimeout(() => {
                                that.to_link()
                            }, 1000);
                        },
                        cancel: (err) => {
                            console.log('取消支付', err)
                            // that.$toast('取消支付')
                            that.isPay = false;
                        },
                        fail: (err) => {
                            console.log('支付失败', err)
                            that.$toast('支付失败')
                            that.isPay = false;
                        }
                    })
                }
            }).catch((err) => {
                that.isPay = false;
                that.$toast(err.msg)
                setTimeout(() => {
                    that.$router.back(-1)
                }, 1000);
            })
        },

        clearTask() {
            clearInterval(this.timerTask)
            this.timerTask = null
        },

        getChannelsInfo() {
            var that = this;
            this.$http.get('/app/channels/getInfo', {
                id: that.id
            }).then(res => {
                console.log("数据" + res)
                that.detail = res.data
                document.title = '订单支付';
            }).catch(err => {
                setTimeout(() => {
                    Toast('网络出现问题，请刷新重试!');
                }, 3000);
            })
        },

        to_link() {
            if (that.pagesType == 'three') {
                this.$router.push({
                    path: '/vxPublic/successTwo',
                    query: { orderId: this.orderId }
                })
            } else {
                this.$router.push({
                    path: '/vxPublic/success',
                    query: { orderId: this.orderId }
                })
            }
        },

        clearTimer() {
            clearInterval(this.intervalId)
            this.intervalId = null
            clearInterval(this.interval_miao);
            this.interval_miao = null;
            this.millisecond = '00';
        },

        updateCountdown(endTime) {
            const now = new Date().getTime()
            const distance = endTime - now

            if (distance < 0) {
                this.minutes = '00'
                this.seconds = '00'
                this.millisecond = '00'
                this.clearTimer()
                return
            }

            this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)) + ''
            this.seconds = Math.floor((distance % (1000 * 60)) / 1000) + ''
            // this.millisecond = parseInt(Math.floor((distance % (1000 * 60)) % 1000) / 10) + ''
            this.minutes = this.minutes.length < 2 ? '0' + this.minutes : this.minutes
            this.seconds = this.seconds.length < 2 ? '0' + this.seconds : this.seconds
            // this.millisecond = this.millisecond.length < 2 ? '0' + this.millisecond : this.millisecond
        },

        checkbox(e) {
            console.log("checkbox" + e)
            this.checked = e;
        },

        getReady() {
            var that = this;
            let shareUrl = window.location.href
            if (shareUrl.indexOf('code=') > 0) {
                shareUrl = shareUrl.match(/(\S*)&code=/)[1]
            }
            console.log('分享的链接', shareUrl)
            console.log('分享的内容', that.detail.courseName)
            wx.updateAppMessageShareData({
                title: `免费领>>5日趣味练字课`, // 分享标题
                desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
                link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
                success: function (res) {
                    // 设置成功
                    // wx.showMenuItems({
                    //   menuList: ['menuItem:share:appMessage'] // 要显示的菜单项，所有menu项见附录3
                    // })
                    console.log('-22-分享success-<')
                },
                fail: e => {
                    console.log('-22-分享fail-<', e)
                }
            })
            wx.updateTimelineShareData({
                title: `免费领>>5日趣味练字课`, // 分享标题
                desc: '5天写出漂亮字，每天练习15分钟，有1对1书法老师点评，让练字变简单！', // 分享描述
                link: shareUrl,
                imgUrl: 'https://mp.51xxc.com/courses/static/conrses_icon.png', // 分享图标
                success: function (res) {
                    // 设置成功
                    // wx.showMenuItems({
                    //   menuList: ['menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
                    // })
                    console.log('-33-分享success-<')
                },
                fail: e => {
                    console.log('-33-分享fail-<', e)
                }
            })
        },

        // 获取地址栏的参数
        getQueryObj() {
            var query = window.location.search
            var queryObj = {}
            var arr = query.slice(1, query.length).split('&')
            arr.forEach(function (val) {
                var arr1 = val.split('=')
                queryObj[arr1[0]] = arr1[1]
            })
            return queryObj
        },

        btnModal(flag) {
            this.show2 = false;
            if (flag) {
                this.show = true;
            }
        },

        closeShow() {
            this.show = false;
            this.show2 = true;
        },

        onFocus(e) {
            setTimeout(() => {
                window.scrollTo({
                    top: document.body.scrollHeight,
                    behavior: 'smooth'
                });
            }, 400);
        },

        getPhone() {
            this.isDanmu = true;
            setTimeout(() => {
                this.isDanmu = false;
                var num = Math.floor(Math.random() * 17);
                var list = [{ avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845065000751828992.jpg", name: "小笑玉" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059170669268992.jpg", name: "李冬丽" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845059032240459776.jpg", name: "时光静好" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845057205503627264.jpg", name: "年年有余" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045951246471168.jpg", name: "一如既往" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845045037685116928.jpg", name: "难得糊涂" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845044890985140224.jpg", name: "刘笑敏" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845010975356456960.jpg", name: "晨光曦影" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845002111324098560.jpg", name: "春暖花开" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1845000414124150784.jpg", name: "风雨过林" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984893706178560.jpg", name: "谢长征" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844984502872543232.jpg", name: "淡然接受" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844311874545487872.jpg", name: "旅途的人" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844288726492090368.jpg", name: "知足常乐" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844280029464334336.jpg", name: "谓我" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844238354637492224.png", name: "陈笑笑" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233814890614784.jpg", name: "丽笑丽" },
                { avatar: "https://xxc-app.oss-cn-shenzhen.aliyuncs.com/1844233663568515072.jpg", name: "凌智科练" }]
                this.danmus.img = list[num].avatar;
                this.danmus.name = list[num].name;
                this.danmus.name = this.danmus.name.charAt(0) + '*'.repeat(this.danmus.name.length - 1) + this.danmus.name.charAt(this.danmus.name.length - 1);
                this.danmus.time = (Math.floor(Math.random() * 60) + 1) + '秒前';
            }, 1000)
        },

    }
}
</script>

<style scoped lang="less">
.container {
    color: #333;
    font-size: 28px;
    // height: 100vh !important;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
}

.footer-fit {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 20px 30px 20px 30px;
    background: #ff6033;
    // background: linear-gradient(45deg, #ff6033, #ff9f33);
    font-family: PingFangSC-Semibold;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .p-left {
        color: #fff;
    }

    .p-right {
        border-radius: 100px;
        background-color: #fff;
        color: #fd7124;
        font-size: 44px;
        font-weight: 700;
        width: 50%;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
}

.header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 32px;
    width: 684px;
    padding: 36px 0;
    border-radius: 32px;
    background-color: #fff;
    border: 1px solid #b4aaaa;

    .paytime {
        color: #fe2d4d;
        text-align: center;

        .time {
            font-size: 56px;
            display: inline-block;
            color: #fe2d4d;
            margin-top: 10px;
            font-weight: bold;
            width: 70px;
        }

        .delimiter {
            display: inline-block;
            margin: 0 8px;
            font-size: 50px;
            font-weight: bold;
        }
    }

    .pay-btn {
        width: 360px;
        margin-top: 30px;
        height: 88px;
        line-height: 88px;
        text-align: center;
        border-radius: 50px;
        font-weight: bolder;
        color: #622c0c;
        font-size: 40px;
        background: #ffe880;
    }

    .overdue {
        font-size: 26px;
        margin-top: 36px;
    }

    .residue {
        margin-bottom: 30px;
        font-size: 32px;
        font-weight: bold;
    }
}

.content2 {
    margin: 0 32px;
    width: 686px;
    // height: 300px;
    background: #fff;
    margin-top: 24px;
    border: 1px solid #b4aaaa;
    border-radius: 32px;

    .record-bg {
        width: 100%;
        position: relative;

        .record-bg-txt {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 36px;
            font-weight: 700;
            color: #fff;
        }
    }

    .content_list {
        height: 500px;
        overflow: hidden;

        .content_list-for {
            animation: scrollup 6s linear infinite;
        }

        @keyframes scrollup {
            0% {
                transform: translateY(0);
            }

            100% {
                transform: translateY(-100%);
            }
        }
    }


    .item {
        display: flex;
        padding: 24px 0;
        margin: 0 24px;
        border-bottom: 1px dashed #cccccc;

        // &:last-child {
        //     border-bottom: none;
        // }

        img {
            width: 60px;
            height: 60px;
            margin-right: 24px;
            border-radius: 30px;
        }

        .right {
            width: 554px;

            .name {
                margin-bottom: 30px;
                font-size: 32px;
                font-weight: bold;
            }

            .desc {
                color: #666;
                font-size: 28px;
            }
        }
    }
}

.danmu {
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 15vh;
    right: 20px;
    padding: 10px 20px;
    background: #00000075;
    color: #fff;
    font-size: 28px;
    border-radius: 50px;
    width: 60%;
}

.fade-in {
    animation: slide-up-fade-in 1s forwards;
}

@keyframes slide-up-fade-in {
    0% {
        transform: translateY(10px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.fade-out {
    animation: slide-up-fade-out 1s forwards;
}

@keyframes slide-up-fade-out {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        transform: translateY(-30px);
        opacity: 0;
    }
}
</style>